import { render } from "./PlotForecast.vue?vue&type=template&id=2027abb0"
import script from "./PlotForecast.vue?vue&type=script&lang=js"
export * from "./PlotForecast.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__